import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';

var Onboarding = /*#__PURE__*/function (_Component) {
  _inherits(Onboarding, _Component);

  var _super = _createSuper(Onboarding);

  function Onboarding(props) {
    var _this;

    _classCallCheck(this, Onboarding);

    _this = _super.call(this, props);
    _this.state = {
      onboarding: false
    };
    return _this;
  }

  _createClass(Onboarding, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement(Joyride, {
        steps: this.props.steps,
        continuous: true,
        locale: {
          back: translate('back'),
          close: translate('close'),
          last: translate('close'),
          next: translate('next'),
          skip: translate('skip')
        },
        run: this.props.onboarding,
        callback: function callback(t) {
          if (t.action == "close" || t.action == "reset") {
            _this2.setState({
              onboarding: false
            });

            if (_this2.props.onExit != null) {
              _this2.props.onExit();
            }
          }
        },
        scrollToFirstStep: true,
        showProgress: true,
        scrollOffset: 150,
        styles: {
          options: {
            primaryColor: '#005da9'
          },
          buttonBack: {
            appearance: 'none',
            color: '#0f0f0f',
            backgroundColor: '#fff',
            border: '1px solid #c9c9c9',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
            borderRadius: '5px',
            padding: '0.85rem 1.7rem',
            fontWeight: 300,
            fontSize: '0.9rem',
            letterSpacing: '0.14px',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Open Sans'
          },
          buttonNext: {
            appearance: 'none',
            color: 'white',
            backgroundColor: '#005da9',
            border: '1px solid #005da9',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
            borderRadius: '5px',
            padding: '0.85rem 1.7rem',
            fontWeight: 300,
            fontSize: '0.9rem',
            letterSpacing: '0.14px',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Open Sans'
          }
        }
      });
    }
  }]);

  return Onboarding;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(Onboarding);